import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authSlice from "./slice/authSlice";
import pricingSlice from "./slice/pricingSlice";
import cartSlice from "./slice/cartSlice";
import specialChargeSlice from "./slice/specialChargeSlice";
import posSlice from "./slice/posSlice";
import customerSlice from "./slice/customerSlice";
import rackSlice from "./slice/rackSlice";
import discountSlice from "./slice/discountSlice";
import merchantSlice from "./slice/merchantSlice";
import masterSlice from "./slice/masterSlice";
import storeSlice from "./slice/storeSlice";
import pinTagSlice from "./slice/pintagSlice";
import instructionsSlice from "./slice/instructionSlice";
import damagesSlice from "./slice/damagesSlice";
import spotsSlice from "./slice/spotSlice";
import upchargeSliceActions from "./slice/upchargeSlice";
import invoiceSlice from "./slice/invoiceSlice";
// import cashierSlice from "./slice/cashierSlice";
// import cashRegisterReducer from "./slice/CashRegisterSlice";
import cashierStationSlice from "./slice/cashierStationSlice";
import boxStorageSlice from "./slice/boxStorageSlice";
import storeClosureDateSlice from "./slice/storeClosureDateSlice";
import customerConfigSlice from "./slice/customerConfigSlice";
import redoReasonsSlice from "./slice/redoReasonsSlice";
import cashDrawerReasonsSlice from "./slice/cashDrawerReasonsSlice";
import priceOverrideConfigSlice from "./slice/priceOverrideConfigSlice";
import managerAccessLogSlice from "./slice/managerAccessLogSlice";
import taxExemptionSlice from "./slice/taxExemptionSlice";
import releaseSlice from "./slice/releaseSlice";
import priceListsSlice from "./slice/priceListsSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    pricing: pricingSlice,
    cart: cartSlice,
    pos: posSlice,
    customer: customerSlice,
    rack: rackSlice,
    pintag: pinTagSlice,
    discount: discountSlice,
    merchant: merchantSlice,
    master: masterSlice,
    store: storeSlice,
    instruction: instructionsSlice,
    damage: damagesSlice,
    spot: spotsSlice,
    upcharge: upchargeSliceActions,
    // cashier: cashierSlice,
    // cashRegister: cashRegisterReducer,
    cashierStation: cashierStationSlice,
    invoice: invoiceSlice,
    boxStorage: boxStorageSlice,
    storeClosureDate: storeClosureDateSlice,
    customerConfig: customerConfigSlice,
    redoReason: redoReasonsSlice,
    cashDrawerReason: cashDrawerReasonsSlice,
    priceOverrideConfig: priceOverrideConfigSlice,
    specialCharge: specialChargeSlice,
    managerAccessLog: managerAccessLogSlice,
    taxExemption: taxExemptionSlice,
    release: releaseSlice,
    priceLists: priceListsSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
